import { ArrowRight, ShieldCheck } from 'lucide-react';
import { IDS } from '@/constants/testIds';

const HERO_BG =
  'https://images.pexels.com/photos/12109677/pexels-photo-12109677.jpeg';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid={IDS.hero.section}
      className="relative min-h-[92vh] w-full overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center animate-slow-zoom"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 hero-overlay" />

      {/* Grid overlay for architectural feel */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-40 pb-24 min-h-[92vh] flex flex-col justify-center">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-3 border border-gold-400/50 bg-navy-900/40 backdrop-blur-sm px-4 py-2 mb-8 animate-fade-up">
            <ShieldCheck className="w-4 h-4 text-gold-300" />
            <span className="text-[11px] tracking-[0.28em] uppercase text-gold-200 font-semibold">
              Registered Government Contractor
            </span>
          </div>

          <h1
            data-testid={IDS.hero.heading}
            className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight animate-fade-up"
            style={{ animationDelay: '120ms' }}
          >
            S.<span className="text-gold-400">K.</span> Infrastructure
            <span className="block text-gold-300 text-3xl sm:text-4xl lg:text-5xl mt-4 italic font-normal">
              Building Today, Empowering Tomorrow.
            </span>
          </h1>

          <p
            className="mt-8 text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed animate-fade-up"
            style={{ animationDelay: '260ms' }}
          >
            Founded in 2026, we are a new-generation civil-works firm registered
            to serve India&rsquo;s government infrastructure needs — from PWD
            and Railways to Municipal and Panchayati Raj works. A young company
            built on modern engineering discipline, safety and integrity.
          </p>

          <div
            className="mt-10 flex flex-wrap items-center gap-4 animate-fade-up"
            style={{ animationDelay: '400ms' }}
          >
            <button
              data-testid={IDS.hero.ctaProjects}
              onClick={() => scrollTo('services')}
              className="group inline-flex items-center gap-3 bg-gold-400 hover:bg-gold-300 text-navy-900 px-8 py-4 text-xs tracking-[0.24em] uppercase font-bold transition-all"
            >
              Explore Our Capabilities
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid={IDS.hero.ctaContact}
              onClick={() => scrollTo('contact')}
              className="inline-flex items-center gap-3 border border-white/60 text-white hover:bg-white hover:text-navy-900 px-8 py-4 text-xs tracking-[0.24em] uppercase font-bold transition-all"
            >
              Request a Consultation
            </button>
          </div>
        </div>

        {/* Bottom strip — commitments (new firm, no delivery history yet) */}
        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/15 border border-white/15 max-w-4xl animate-fade-up" style={{ animationDelay: '540ms' }}>
          {[
            ['Est. 2026', 'Newly Founded'],
            ['Railways', 'Registered Contractor'],
            ['Multi-Dept', 'Empanelment Ready'],
            ['GST', 'MSME Compliant'],
          ].map(([n, l]) => (
            <div key={l} className="bg-navy-900/60 backdrop-blur-sm px-5 py-6">
              <div className="font-serif text-2xl text-gold-300">{n}</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-white/70 mt-1">{l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
